export default {
  name: '学习卡',
  permissionsKey:"JG-XXK",
  icon: 'el-icon-s-management',
  children: {
    courseList:{
      name: '学习卡管理',
      permissionsKey:"JG-XXK-XXKGL",
      path: '/course_manage/course_list',
    },
    testPaperAnalysis:{
      name: '分配记录',
      permissionsKey:"JG-XXK-FKJL",
      path: '/course_manage/study_card',
    },
  }
};
